// Studio glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = a lucide-react component, as in Icon.tsx.

export { studioGlyphs };

import {
    ArrowRightLeft,
    BookOpen,
    CircleCheck,
    CircleDashed,
    CircleQuestionMark,
    Crosshair,
    FileSearch,
    FileText,
    Heading2,
    Heading3,
    RotateCcwClock,
    Sparkle,
    Target,
} from "lucide-react";
import type { AreaGlyphs } from "../Icon";

const studioGlyphs = {
    history: RotateCcwClock, // what happened in the project (the top bar's History)
    crosshair: Crosshair, // what the assistant works on (the composer's scope)
    target: Target, // the outline's Learning objectives row
    "circle-check": CircleCheck, // coverage: a quiz checks the objective
    "circle-dashed": CircleDashed, // coverage: a planned part should cover it
    // The Create menu's rows.
    ask: Sparkle, // Ask here, and the margin of the line that asks (pen Q66)
    "book-open": BookOpen,
    "file-search": FileSearch,
    "file-text": FileText,
    // How it lands in Torus / Canvas: a block that changes shape on export.
    "arrow-right-left": ArrowRightLeft,
    question: CircleQuestionMark, // a quiz question's tile (pen "Always writing")
    // The block menu's Turn into (pen Q76): Heading and Subheading.
    "heading-2": Heading2,
    "heading-3": Heading3,
} satisfies AreaGlyphs;
